<mf-column-display label="Titular de la cuenta">
  {{ getHolderName() }}
</mf-column-display>
<mf-column-display label="Moneda de la cuenta">
  {{ getCurrencies() }}
</mf-column-display>
